/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CalibrarModelosRouteImport } from './routes/calibrar-modelos'
import { Route as ConfirmarEmailRouteImport } from './routes/confirmar-email'
import { Route as EsqueciSenhaRouteImport } from './routes/esqueci-senha'
import { Route as RedefinirSenhaRouteImport } from './routes/redefinir-senha'
import { Route as AdminPainelRouteImport } from './routes/admin/_painel'
import { Route as AdminEntrarRouteImport } from './routes/admin/entrar'
import { Route as MinhaContaContaRouteImport } from './routes/minha-conta/_conta'
import { Route as MinhaContaEntrarRouteImport } from './routes/minha-conta/entrar'
import { Route as RevendedorAreaRouteImport } from './routes/revendedor/_area'
import { Route as AdminPainelConfiguracoesRouteImport } from './routes/admin/_painel/configuracoes'
import { Route as AdminPainelRelatoriosRouteImport } from './routes/admin/_painel/relatorios'
import { Route as AdminPainelRepassesRouteImport } from './routes/admin/_painel/repasses'
import { Route as MinhaContaContaDadosRouteImport } from './routes/minha-conta/_conta/dados'
import { Route as RCodeIndexRouteImport } from './routes/r/$code/index'
import { Route as RCodeCampaignRouteImport } from './routes/r/$code/$campaign'
import { Route as RevendedorAreaIndexRouteImport } from './routes/revendedor/_area/index'
import { Route as RevendedorAreaClientesRouteImport } from './routes/revendedor/_area/clientes'
import { Route as RevendedorAreaComissoesRouteImport } from './routes/revendedor/_area/comissoes'
import { Route as RevendedorAreaDadosRouteImport } from './routes/revendedor/_area/dados'
import { Route as RevendedorAreaVendasRouteImport } from './routes/revendedor/_area/vendas'
import { Route as AdminPainelCatalogoIndexRouteImport } from './routes/admin/_painel/catalogo/index'
import { Route as AdminPainelClientesIndexRouteImport } from './routes/admin/_painel/clientes/index'
import { Route as AdminPainelClientesClienteIdRouteImport } from './routes/admin/_painel/clientes/$clienteId'
import { Route as AdminPainelEquipeIndexRouteImport } from './routes/admin/_painel/equipe/index'
import { Route as AdminPainelEquipeMembroIdRouteImport } from './routes/admin/_painel/equipe/$membroId'
import { Route as AdminPainelPedidosIndexRouteImport } from './routes/admin/_painel/pedidos/index'
import { Route as AdminPainelPedidosPedidoIdRouteImport } from './routes/admin/_painel/pedidos/$pedidoId'
import { Route as MinhaContaContaPedidosIndexRouteImport } from './routes/minha-conta/_conta/pedidos/index'
import { Route as MinhaContaContaPedidosPedidoIdRouteImport } from './routes/minha-conta/_conta/pedidos/$pedidoId'
import { Route as RevendedorAreaCampanhasIndexRouteImport } from './routes/revendedor/_area/campanhas/index'
import { Route as RevendedorAreaCampanhasCampanhaIdRouteImport } from './routes/revendedor/_area/campanhas/$campanhaId'
import { Route as AdminPainelCatalogoPecasPieceIdRouteImport } from './routes/admin/_painel/catalogo/pecas/$pieceId'
import { Route as AdminPainelRelatoriosCampanhasCampanhaIdRouteImport } from './routes/admin/_painel/relatorios_.campanhas.$campanhaId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CalibrarModelosRoute = CalibrarModelosRouteImport.update({
  id: '/calibrar-modelos',
  path: '/calibrar-modelos',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfirmarEmailRoute = ConfirmarEmailRouteImport.update({
  id: '/confirmar-email',
  path: '/confirmar-email',
  getParentRoute: () => rootRouteImport,
} as any)
const EsqueciSenhaRoute = EsqueciSenhaRouteImport.update({
  id: '/esqueci-senha',
  path: '/esqueci-senha',
  getParentRoute: () => rootRouteImport,
} as any)
const RedefinirSenhaRoute = RedefinirSenhaRouteImport.update({
  id: '/redefinir-senha',
  path: '/redefinir-senha',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPainelRoute = AdminPainelRouteImport.update({
  id: '/admin/_painel',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminEntrarRoute = AdminEntrarRouteImport.update({
  id: '/admin/entrar',
  path: '/admin/entrar',
  getParentRoute: () => rootRouteImport,
} as any)
const MinhaContaContaRoute = MinhaContaContaRouteImport.update({
  id: '/minha-conta/_conta',
  path: '/minha-conta',
  getParentRoute: () => rootRouteImport,
} as any)
const MinhaContaEntrarRoute = MinhaContaEntrarRouteImport.update({
  id: '/minha-conta/entrar',
  path: '/minha-conta/entrar',
  getParentRoute: () => rootRouteImport,
} as any)
const RevendedorAreaRoute = RevendedorAreaRouteImport.update({
  id: '/revendedor/_area',
  path: '/revendedor',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPainelConfiguracoesRoute =
  AdminPainelConfiguracoesRouteImport.update({
    id: '/configuracoes',
    path: '/configuracoes',
    getParentRoute: () => AdminPainelRoute,
  } as any)
const AdminPainelRelatoriosRoute = AdminPainelRelatoriosRouteImport.update({
  id: '/relatorios',
  path: '/relatorios',
  getParentRoute: () => AdminPainelRoute,
} as any)
const AdminPainelRepassesRoute = AdminPainelRepassesRouteImport.update({
  id: '/repasses',
  path: '/repasses',
  getParentRoute: () => AdminPainelRoute,
} as any)
const MinhaContaContaDadosRoute = MinhaContaContaDadosRouteImport.update({
  id: '/dados',
  path: '/dados',
  getParentRoute: () => MinhaContaContaRoute,
} as any)
const RCodeIndexRoute = RCodeIndexRouteImport.update({
  id: '/r/$code/',
  path: '/r/$code/',
  getParentRoute: () => rootRouteImport,
} as any)
const RCodeCampaignRoute = RCodeCampaignRouteImport.update({
  id: '/r/$code/$campaign',
  path: '/r/$code/$campaign',
  getParentRoute: () => rootRouteImport,
} as any)
const RevendedorAreaIndexRoute = RevendedorAreaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RevendedorAreaRoute,
} as any)
const RevendedorAreaClientesRoute = RevendedorAreaClientesRouteImport.update({
  id: '/clientes',
  path: '/clientes',
  getParentRoute: () => RevendedorAreaRoute,
} as any)
const RevendedorAreaComissoesRoute = RevendedorAreaComissoesRouteImport.update({
  id: '/comissoes',
  path: '/comissoes',
  getParentRoute: () => RevendedorAreaRoute,
} as any)
const RevendedorAreaDadosRoute = RevendedorAreaDadosRouteImport.update({
  id: '/dados',
  path: '/dados',
  getParentRoute: () => RevendedorAreaRoute,
} as any)
const RevendedorAreaVendasRoute = RevendedorAreaVendasRouteImport.update({
  id: '/vendas',
  path: '/vendas',
  getParentRoute: () => RevendedorAreaRoute,
} as any)
const AdminPainelCatalogoIndexRoute =
  AdminPainelCatalogoIndexRouteImport.update({
    id: '/catalogo/',
    path: '/catalogo/',
    getParentRoute: () => AdminPainelRoute,
  } as any)
const AdminPainelClientesIndexRoute =
  AdminPainelClientesIndexRouteImport.update({
    id: '/clientes/',
    path: '/clientes/',
    getParentRoute: () => AdminPainelRoute,
  } as any)
const AdminPainelClientesClienteIdRoute =
  AdminPainelClientesClienteIdRouteImport.update({
    id: '/clientes/$clienteId',
    path: '/clientes/$clienteId',
    getParentRoute: () => AdminPainelRoute,
  } as any)
const AdminPainelEquipeIndexRoute = AdminPainelEquipeIndexRouteImport.update({
  id: '/equipe/',
  path: '/equipe/',
  getParentRoute: () => AdminPainelRoute,
} as any)
const AdminPainelEquipeMembroIdRoute =
  AdminPainelEquipeMembroIdRouteImport.update({
    id: '/equipe/$membroId',
    path: '/equipe/$membroId',
    getParentRoute: () => AdminPainelRoute,
  } as any)
const AdminPainelPedidosIndexRoute = AdminPainelPedidosIndexRouteImport.update({
  id: '/pedidos/',
  path: '/pedidos/',
  getParentRoute: () => AdminPainelRoute,
} as any)
const AdminPainelPedidosPedidoIdRoute =
  AdminPainelPedidosPedidoIdRouteImport.update({
    id: '/pedidos/$pedidoId',
    path: '/pedidos/$pedidoId',
    getParentRoute: () => AdminPainelRoute,
  } as any)
const MinhaContaContaPedidosIndexRoute =
  MinhaContaContaPedidosIndexRouteImport.update({
    id: '/pedidos/',
    path: '/pedidos/',
    getParentRoute: () => MinhaContaContaRoute,
  } as any)
const MinhaContaContaPedidosPedidoIdRoute =
  MinhaContaContaPedidosPedidoIdRouteImport.update({
    id: '/pedidos/$pedidoId',
    path: '/pedidos/$pedidoId',
    getParentRoute: () => MinhaContaContaRoute,
  } as any)
const RevendedorAreaCampanhasIndexRoute =
  RevendedorAreaCampanhasIndexRouteImport.update({
    id: '/campanhas/',
    path: '/campanhas/',
    getParentRoute: () => RevendedorAreaRoute,
  } as any)
const RevendedorAreaCampanhasCampanhaIdRoute =
  RevendedorAreaCampanhasCampanhaIdRouteImport.update({
    id: '/campanhas/$campanhaId',
    path: '/campanhas/$campanhaId',
    getParentRoute: () => RevendedorAreaRoute,
  } as any)
const AdminPainelCatalogoPecasPieceIdRoute =
  AdminPainelCatalogoPecasPieceIdRouteImport.update({
    id: '/catalogo/pecas/$pieceId',
    path: '/catalogo/pecas/$pieceId',
    getParentRoute: () => AdminPainelRoute,
  } as any)
const AdminPainelRelatoriosCampanhasCampanhaIdRoute =
  AdminPainelRelatoriosCampanhasCampanhaIdRouteImport.update({
    id: '/relatorios_/campanhas/$campanhaId',
    path: '/relatorios/campanhas/$campanhaId',
    getParentRoute: () => AdminPainelRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/calibrar-modelos': typeof CalibrarModelosRoute
  '/confirmar-email': typeof ConfirmarEmailRoute
  '/esqueci-senha': typeof EsqueciSenhaRoute
  '/redefinir-senha': typeof RedefinirSenhaRoute
  '/admin': typeof AdminPainelRouteWithChildren
  '/admin/entrar': typeof AdminEntrarRoute
  '/minha-conta': typeof MinhaContaContaRouteWithChildren
  '/minha-conta/entrar': typeof MinhaContaEntrarRoute
  '/revendedor': typeof RevendedorAreaRouteWithChildren
  '/admin/configuracoes': typeof AdminPainelConfiguracoesRoute
  '/admin/relatorios': typeof AdminPainelRelatoriosRoute
  '/admin/repasses': typeof AdminPainelRepassesRoute
  '/minha-conta/dados': typeof MinhaContaContaDadosRoute
  '/r/$code/$campaign': typeof RCodeCampaignRoute
  '/revendedor/clientes': typeof RevendedorAreaClientesRoute
  '/revendedor/comissoes': typeof RevendedorAreaComissoesRoute
  '/revendedor/dados': typeof RevendedorAreaDadosRoute
  '/revendedor/vendas': typeof RevendedorAreaVendasRoute
  '/r/$code/': typeof RCodeIndexRoute
  '/revendedor/': typeof RevendedorAreaIndexRoute
  '/admin/clientes/$clienteId': typeof AdminPainelClientesClienteIdRoute
  '/admin/equipe/$membroId': typeof AdminPainelEquipeMembroIdRoute
  '/admin/pedidos/$pedidoId': typeof AdminPainelPedidosPedidoIdRoute
  '/minha-conta/pedidos/$pedidoId': typeof MinhaContaContaPedidosPedidoIdRoute
  '/revendedor/campanhas/$campanhaId': typeof RevendedorAreaCampanhasCampanhaIdRoute
  '/admin/catalogo/': typeof AdminPainelCatalogoIndexRoute
  '/admin/clientes/': typeof AdminPainelClientesIndexRoute
  '/admin/equipe/': typeof AdminPainelEquipeIndexRoute
  '/admin/pedidos/': typeof AdminPainelPedidosIndexRoute
  '/minha-conta/pedidos/': typeof MinhaContaContaPedidosIndexRoute
  '/revendedor/campanhas/': typeof RevendedorAreaCampanhasIndexRoute
  '/admin/catalogo/pecas/$pieceId': typeof AdminPainelCatalogoPecasPieceIdRoute
  '/admin/relatorios/campanhas/$campanhaId': typeof AdminPainelRelatoriosCampanhasCampanhaIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/calibrar-modelos': typeof CalibrarModelosRoute
  '/confirmar-email': typeof ConfirmarEmailRoute
  '/esqueci-senha': typeof EsqueciSenhaRoute
  '/redefinir-senha': typeof RedefinirSenhaRoute
  '/admin': typeof AdminPainelRouteWithChildren
  '/admin/entrar': typeof AdminEntrarRoute
  '/minha-conta': typeof MinhaContaContaRouteWithChildren
  '/minha-conta/entrar': typeof MinhaContaEntrarRoute
  '/admin/configuracoes': typeof AdminPainelConfiguracoesRoute
  '/admin/relatorios': typeof AdminPainelRelatoriosRoute
  '/admin/repasses': typeof AdminPainelRepassesRoute
  '/minha-conta/dados': typeof MinhaContaContaDadosRoute
  '/r/$code/$campaign': typeof RCodeCampaignRoute
  '/revendedor/clientes': typeof RevendedorAreaClientesRoute
  '/revendedor/comissoes': typeof RevendedorAreaComissoesRoute
  '/revendedor/dados': typeof RevendedorAreaDadosRoute
  '/revendedor/vendas': typeof RevendedorAreaVendasRoute
  '/r/$code': typeof RCodeIndexRoute
  '/revendedor': typeof RevendedorAreaIndexRoute
  '/admin/clientes/$clienteId': typeof AdminPainelClientesClienteIdRoute
  '/admin/equipe/$membroId': typeof AdminPainelEquipeMembroIdRoute
  '/admin/pedidos/$pedidoId': typeof AdminPainelPedidosPedidoIdRoute
  '/minha-conta/pedidos/$pedidoId': typeof MinhaContaContaPedidosPedidoIdRoute
  '/revendedor/campanhas/$campanhaId': typeof RevendedorAreaCampanhasCampanhaIdRoute
  '/admin/catalogo': typeof AdminPainelCatalogoIndexRoute
  '/admin/clientes': typeof AdminPainelClientesIndexRoute
  '/admin/equipe': typeof AdminPainelEquipeIndexRoute
  '/admin/pedidos': typeof AdminPainelPedidosIndexRoute
  '/minha-conta/pedidos': typeof MinhaContaContaPedidosIndexRoute
  '/revendedor/campanhas': typeof RevendedorAreaCampanhasIndexRoute
  '/admin/catalogo/pecas/$pieceId': typeof AdminPainelCatalogoPecasPieceIdRoute
  '/admin/relatorios/campanhas/$campanhaId': typeof AdminPainelRelatoriosCampanhasCampanhaIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/calibrar-modelos': typeof CalibrarModelosRoute
  '/confirmar-email': typeof ConfirmarEmailRoute
  '/esqueci-senha': typeof EsqueciSenhaRoute
  '/redefinir-senha': typeof RedefinirSenhaRoute
  '/admin/_painel': typeof AdminPainelRouteWithChildren
  '/admin/entrar': typeof AdminEntrarRoute
  '/minha-conta/_conta': typeof MinhaContaContaRouteWithChildren
  '/minha-conta/entrar': typeof MinhaContaEntrarRoute
  '/revendedor/_area': typeof RevendedorAreaRouteWithChildren
  '/admin/_painel/configuracoes': typeof AdminPainelConfiguracoesRoute
  '/admin/_painel/relatorios': typeof AdminPainelRelatoriosRoute
  '/admin/_painel/repasses': typeof AdminPainelRepassesRoute
  '/minha-conta/_conta/dados': typeof MinhaContaContaDadosRoute
  '/r/$code/$campaign': typeof RCodeCampaignRoute
  '/revendedor/_area/clientes': typeof RevendedorAreaClientesRoute
  '/revendedor/_area/comissoes': typeof RevendedorAreaComissoesRoute
  '/revendedor/_area/dados': typeof RevendedorAreaDadosRoute
  '/revendedor/_area/vendas': typeof RevendedorAreaVendasRoute
  '/r/$code/': typeof RCodeIndexRoute
  '/revendedor/_area/': typeof RevendedorAreaIndexRoute
  '/admin/_painel/clientes/$clienteId': typeof AdminPainelClientesClienteIdRoute
  '/admin/_painel/equipe/$membroId': typeof AdminPainelEquipeMembroIdRoute
  '/admin/_painel/pedidos/$pedidoId': typeof AdminPainelPedidosPedidoIdRoute
  '/minha-conta/_conta/pedidos/$pedidoId': typeof MinhaContaContaPedidosPedidoIdRoute
  '/revendedor/_area/campanhas/$campanhaId': typeof RevendedorAreaCampanhasCampanhaIdRoute
  '/admin/_painel/catalogo/': typeof AdminPainelCatalogoIndexRoute
  '/admin/_painel/clientes/': typeof AdminPainelClientesIndexRoute
  '/admin/_painel/equipe/': typeof AdminPainelEquipeIndexRoute
  '/admin/_painel/pedidos/': typeof AdminPainelPedidosIndexRoute
  '/minha-conta/_conta/pedidos/': typeof MinhaContaContaPedidosIndexRoute
  '/revendedor/_area/campanhas/': typeof RevendedorAreaCampanhasIndexRoute
  '/admin/_painel/catalogo/pecas/$pieceId': typeof AdminPainelCatalogoPecasPieceIdRoute
  '/admin/_painel/relatorios_/campanhas/$campanhaId': typeof AdminPainelRelatoriosCampanhasCampanhaIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/calibrar-modelos'
    | '/confirmar-email'
    | '/esqueci-senha'
    | '/redefinir-senha'
    | '/admin'
    | '/admin/entrar'
    | '/minha-conta'
    | '/minha-conta/entrar'
    | '/revendedor'
    | '/admin/configuracoes'
    | '/admin/relatorios'
    | '/admin/repasses'
    | '/minha-conta/dados'
    | '/r/$code/$campaign'
    | '/revendedor/clientes'
    | '/revendedor/comissoes'
    | '/revendedor/dados'
    | '/revendedor/vendas'
    | '/r/$code/'
    | '/revendedor/'
    | '/admin/clientes/$clienteId'
    | '/admin/equipe/$membroId'
    | '/admin/pedidos/$pedidoId'
    | '/minha-conta/pedidos/$pedidoId'
    | '/revendedor/campanhas/$campanhaId'
    | '/admin/catalogo/'
    | '/admin/clientes/'
    | '/admin/equipe/'
    | '/admin/pedidos/'
    | '/minha-conta/pedidos/'
    | '/revendedor/campanhas/'
    | '/admin/catalogo/pecas/$pieceId'
    | '/admin/relatorios/campanhas/$campanhaId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/calibrar-modelos'
    | '/confirmar-email'
    | '/esqueci-senha'
    | '/redefinir-senha'
    | '/admin'
    | '/admin/entrar'
    | '/minha-conta'
    | '/minha-conta/entrar'
    | '/admin/configuracoes'
    | '/admin/relatorios'
    | '/admin/repasses'
    | '/minha-conta/dados'
    | '/r/$code/$campaign'
    | '/revendedor/clientes'
    | '/revendedor/comissoes'
    | '/revendedor/dados'
    | '/revendedor/vendas'
    | '/r/$code'
    | '/revendedor'
    | '/admin/clientes/$clienteId'
    | '/admin/equipe/$membroId'
    | '/admin/pedidos/$pedidoId'
    | '/minha-conta/pedidos/$pedidoId'
    | '/revendedor/campanhas/$campanhaId'
    | '/admin/catalogo'
    | '/admin/clientes'
    | '/admin/equipe'
    | '/admin/pedidos'
    | '/minha-conta/pedidos'
    | '/revendedor/campanhas'
    | '/admin/catalogo/pecas/$pieceId'
    | '/admin/relatorios/campanhas/$campanhaId'
  id:
    | '__root__'
    | '/'
    | '/calibrar-modelos'
    | '/confirmar-email'
    | '/esqueci-senha'
    | '/redefinir-senha'
    | '/admin/_painel'
    | '/admin/entrar'
    | '/minha-conta/_conta'
    | '/minha-conta/entrar'
    | '/revendedor/_area'
    | '/admin/_painel/configuracoes'
    | '/admin/_painel/relatorios'
    | '/admin/_painel/repasses'
    | '/minha-conta/_conta/dados'
    | '/r/$code/$campaign'
    | '/revendedor/_area/clientes'
    | '/revendedor/_area/comissoes'
    | '/revendedor/_area/dados'
    | '/revendedor/_area/vendas'
    | '/r/$code/'
    | '/revendedor/_area/'
    | '/admin/_painel/clientes/$clienteId'
    | '/admin/_painel/equipe/$membroId'
    | '/admin/_painel/pedidos/$pedidoId'
    | '/minha-conta/_conta/pedidos/$pedidoId'
    | '/revendedor/_area/campanhas/$campanhaId'
    | '/admin/_painel/catalogo/'
    | '/admin/_painel/clientes/'
    | '/admin/_painel/equipe/'
    | '/admin/_painel/pedidos/'
    | '/minha-conta/_conta/pedidos/'
    | '/revendedor/_area/campanhas/'
    | '/admin/_painel/catalogo/pecas/$pieceId'
    | '/admin/_painel/relatorios_/campanhas/$campanhaId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CalibrarModelosRoute: typeof CalibrarModelosRoute
  ConfirmarEmailRoute: typeof ConfirmarEmailRoute
  EsqueciSenhaRoute: typeof EsqueciSenhaRoute
  RedefinirSenhaRoute: typeof RedefinirSenhaRoute
  AdminPainelRoute: typeof AdminPainelRouteWithChildren
  AdminEntrarRoute: typeof AdminEntrarRoute
  MinhaContaContaRoute: typeof MinhaContaContaRouteWithChildren
  MinhaContaEntrarRoute: typeof MinhaContaEntrarRoute
  RevendedorAreaRoute: typeof RevendedorAreaRouteWithChildren
  RCodeCampaignRoute: typeof RCodeCampaignRoute
  RCodeIndexRoute: typeof RCodeIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calibrar-modelos': {
      id: '/calibrar-modelos'
      path: '/calibrar-modelos'
      fullPath: '/calibrar-modelos'
      preLoaderRoute: typeof CalibrarModelosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confirmar-email': {
      id: '/confirmar-email'
      path: '/confirmar-email'
      fullPath: '/confirmar-email'
      preLoaderRoute: typeof ConfirmarEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/esqueci-senha': {
      id: '/esqueci-senha'
      path: '/esqueci-senha'
      fullPath: '/esqueci-senha'
      preLoaderRoute: typeof EsqueciSenhaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/redefinir-senha': {
      id: '/redefinir-senha'
      path: '/redefinir-senha'
      fullPath: '/redefinir-senha'
      preLoaderRoute: typeof RedefinirSenhaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/_painel': {
      id: '/admin/_painel'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminPainelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/entrar': {
      id: '/admin/entrar'
      path: '/admin/entrar'
      fullPath: '/admin/entrar'
      preLoaderRoute: typeof AdminEntrarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/minha-conta/_conta': {
      id: '/minha-conta/_conta'
      path: '/minha-conta'
      fullPath: '/minha-conta'
      preLoaderRoute: typeof MinhaContaContaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/minha-conta/entrar': {
      id: '/minha-conta/entrar'
      path: '/minha-conta/entrar'
      fullPath: '/minha-conta/entrar'
      preLoaderRoute: typeof MinhaContaEntrarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/revendedor/_area': {
      id: '/revendedor/_area'
      path: '/revendedor'
      fullPath: '/revendedor'
      preLoaderRoute: typeof RevendedorAreaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/_painel/configuracoes': {
      id: '/admin/_painel/configuracoes'
      path: '/configuracoes'
      fullPath: '/admin/configuracoes'
      preLoaderRoute: typeof AdminPainelConfiguracoesRouteImport
      parentRoute: typeof AdminPainelRoute
    }
    '/admin/_painel/relatorios': {
      id: '/admin/_painel/relatorios'
      path: '/relatorios'
      fullPath: '/admin/relatorios'
      preLoaderRoute: typeof AdminPainelRelatoriosRouteImport
      parentRoute: typeof AdminPainelRoute
    }
    '/admin/_painel/repasses': {
      id: '/admin/_painel/repasses'
      path: '/repasses'
      fullPath: '/admin/repasses'
      preLoaderRoute: typeof AdminPainelRepassesRouteImport
      parentRoute: typeof AdminPainelRoute
    }
    '/minha-conta/_conta/dados': {
      id: '/minha-conta/_conta/dados'
      path: '/dados'
      fullPath: '/minha-conta/dados'
      preLoaderRoute: typeof MinhaContaContaDadosRouteImport
      parentRoute: typeof MinhaContaContaRoute
    }
    '/r/$code/': {
      id: '/r/$code/'
      path: '/r/$code'
      fullPath: '/r/$code/'
      preLoaderRoute: typeof RCodeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/r/$code/$campaign': {
      id: '/r/$code/$campaign'
      path: '/r/$code/$campaign'
      fullPath: '/r/$code/$campaign'
      preLoaderRoute: typeof RCodeCampaignRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/revendedor/_area/': {
      id: '/revendedor/_area/'
      path: '/'
      fullPath: '/revendedor/'
      preLoaderRoute: typeof RevendedorAreaIndexRouteImport
      parentRoute: typeof RevendedorAreaRoute
    }
    '/revendedor/_area/clientes': {
      id: '/revendedor/_area/clientes'
      path: '/clientes'
      fullPath: '/revendedor/clientes'
      preLoaderRoute: typeof RevendedorAreaClientesRouteImport
      parentRoute: typeof RevendedorAreaRoute
    }
    '/revendedor/_area/comissoes': {
      id: '/revendedor/_area/comissoes'
      path: '/comissoes'
      fullPath: '/revendedor/comissoes'
      preLoaderRoute: typeof RevendedorAreaComissoesRouteImport
      parentRoute: typeof RevendedorAreaRoute
    }
    '/revendedor/_area/dados': {
      id: '/revendedor/_area/dados'
      path: '/dados'
      fullPath: '/revendedor/dados'
      preLoaderRoute: typeof RevendedorAreaDadosRouteImport
      parentRoute: typeof RevendedorAreaRoute
    }
    '/revendedor/_area/vendas': {
      id: '/revendedor/_area/vendas'
      path: '/vendas'
      fullPath: '/revendedor/vendas'
      preLoaderRoute: typeof RevendedorAreaVendasRouteImport
      parentRoute: typeof RevendedorAreaRoute
    }
    '/admin/_painel/catalogo/': {
      id: '/admin/_painel/catalogo/'
      path: '/catalogo'
      fullPath: '/admin/catalogo/'
      preLoaderRoute: typeof AdminPainelCatalogoIndexRouteImport
      parentRoute: typeof AdminPainelRoute
    }
    '/admin/_painel/clientes/': {
      id: '/admin/_painel/clientes/'
      path: '/clientes'
      fullPath: '/admin/clientes/'
      preLoaderRoute: typeof AdminPainelClientesIndexRouteImport
      parentRoute: typeof AdminPainelRoute
    }
    '/admin/_painel/clientes/$clienteId': {
      id: '/admin/_painel/clientes/$clienteId'
      path: '/clientes/$clienteId'
      fullPath: '/admin/clientes/$clienteId'
      preLoaderRoute: typeof AdminPainelClientesClienteIdRouteImport
      parentRoute: typeof AdminPainelRoute
    }
    '/admin/_painel/equipe/': {
      id: '/admin/_painel/equipe/'
      path: '/equipe'
      fullPath: '/admin/equipe/'
      preLoaderRoute: typeof AdminPainelEquipeIndexRouteImport
      parentRoute: typeof AdminPainelRoute
    }
    '/admin/_painel/equipe/$membroId': {
      id: '/admin/_painel/equipe/$membroId'
      path: '/equipe/$membroId'
      fullPath: '/admin/equipe/$membroId'
      preLoaderRoute: typeof AdminPainelEquipeMembroIdRouteImport
      parentRoute: typeof AdminPainelRoute
    }
    '/admin/_painel/pedidos/': {
      id: '/admin/_painel/pedidos/'
      path: '/pedidos'
      fullPath: '/admin/pedidos/'
      preLoaderRoute: typeof AdminPainelPedidosIndexRouteImport
      parentRoute: typeof AdminPainelRoute
    }
    '/admin/_painel/pedidos/$pedidoId': {
      id: '/admin/_painel/pedidos/$pedidoId'
      path: '/pedidos/$pedidoId'
      fullPath: '/admin/pedidos/$pedidoId'
      preLoaderRoute: typeof AdminPainelPedidosPedidoIdRouteImport
      parentRoute: typeof AdminPainelRoute
    }
    '/minha-conta/_conta/pedidos/': {
      id: '/minha-conta/_conta/pedidos/'
      path: '/pedidos'
      fullPath: '/minha-conta/pedidos/'
      preLoaderRoute: typeof MinhaContaContaPedidosIndexRouteImport
      parentRoute: typeof MinhaContaContaRoute
    }
    '/minha-conta/_conta/pedidos/$pedidoId': {
      id: '/minha-conta/_conta/pedidos/$pedidoId'
      path: '/pedidos/$pedidoId'
      fullPath: '/minha-conta/pedidos/$pedidoId'
      preLoaderRoute: typeof MinhaContaContaPedidosPedidoIdRouteImport
      parentRoute: typeof MinhaContaContaRoute
    }
    '/revendedor/_area/campanhas/': {
      id: '/revendedor/_area/campanhas/'
      path: '/campanhas'
      fullPath: '/revendedor/campanhas/'
      preLoaderRoute: typeof RevendedorAreaCampanhasIndexRouteImport
      parentRoute: typeof RevendedorAreaRoute
    }
    '/revendedor/_area/campanhas/$campanhaId': {
      id: '/revendedor/_area/campanhas/$campanhaId'
      path: '/campanhas/$campanhaId'
      fullPath: '/revendedor/campanhas/$campanhaId'
      preLoaderRoute: typeof RevendedorAreaCampanhasCampanhaIdRouteImport
      parentRoute: typeof RevendedorAreaRoute
    }
    '/admin/_painel/catalogo/pecas/$pieceId': {
      id: '/admin/_painel/catalogo/pecas/$pieceId'
      path: '/catalogo/pecas/$pieceId'
      fullPath: '/admin/catalogo/pecas/$pieceId'
      preLoaderRoute: typeof AdminPainelCatalogoPecasPieceIdRouteImport
      parentRoute: typeof AdminPainelRoute
    }
    '/admin/_painel/relatorios_/campanhas/$campanhaId': {
      id: '/admin/_painel/relatorios_/campanhas/$campanhaId'
      path: '/relatorios/campanhas/$campanhaId'
      fullPath: '/admin/relatorios/campanhas/$campanhaId'
      preLoaderRoute: typeof AdminPainelRelatoriosCampanhasCampanhaIdRouteImport
      parentRoute: typeof AdminPainelRoute
    }
  }
}

interface AdminPainelRouteChildren {
  AdminPainelConfiguracoesRoute: typeof AdminPainelConfiguracoesRoute
  AdminPainelRelatoriosRoute: typeof AdminPainelRelatoriosRoute
  AdminPainelRepassesRoute: typeof AdminPainelRepassesRoute
  AdminPainelClientesClienteIdRoute: typeof AdminPainelClientesClienteIdRoute
  AdminPainelEquipeMembroIdRoute: typeof AdminPainelEquipeMembroIdRoute
  AdminPainelPedidosPedidoIdRoute: typeof AdminPainelPedidosPedidoIdRoute
  AdminPainelCatalogoIndexRoute: typeof AdminPainelCatalogoIndexRoute
  AdminPainelClientesIndexRoute: typeof AdminPainelClientesIndexRoute
  AdminPainelEquipeIndexRoute: typeof AdminPainelEquipeIndexRoute
  AdminPainelPedidosIndexRoute: typeof AdminPainelPedidosIndexRoute
  AdminPainelCatalogoPecasPieceIdRoute: typeof AdminPainelCatalogoPecasPieceIdRoute
  AdminPainelRelatoriosCampanhasCampanhaIdRoute: typeof AdminPainelRelatoriosCampanhasCampanhaIdRoute
}

const AdminPainelRouteChildren: AdminPainelRouteChildren = {
  AdminPainelConfiguracoesRoute: AdminPainelConfiguracoesRoute,
  AdminPainelRelatoriosRoute: AdminPainelRelatoriosRoute,
  AdminPainelRepassesRoute: AdminPainelRepassesRoute,
  AdminPainelClientesClienteIdRoute: AdminPainelClientesClienteIdRoute,
  AdminPainelEquipeMembroIdRoute: AdminPainelEquipeMembroIdRoute,
  AdminPainelPedidosPedidoIdRoute: AdminPainelPedidosPedidoIdRoute,
  AdminPainelCatalogoIndexRoute: AdminPainelCatalogoIndexRoute,
  AdminPainelClientesIndexRoute: AdminPainelClientesIndexRoute,
  AdminPainelEquipeIndexRoute: AdminPainelEquipeIndexRoute,
  AdminPainelPedidosIndexRoute: AdminPainelPedidosIndexRoute,
  AdminPainelCatalogoPecasPieceIdRoute: AdminPainelCatalogoPecasPieceIdRoute,
  AdminPainelRelatoriosCampanhasCampanhaIdRoute:
    AdminPainelRelatoriosCampanhasCampanhaIdRoute,
}

const AdminPainelRouteWithChildren = AdminPainelRoute._addFileChildren(
  AdminPainelRouteChildren,
)

interface MinhaContaContaRouteChildren {
  MinhaContaContaDadosRoute: typeof MinhaContaContaDadosRoute
  MinhaContaContaPedidosPedidoIdRoute: typeof MinhaContaContaPedidosPedidoIdRoute
  MinhaContaContaPedidosIndexRoute: typeof MinhaContaContaPedidosIndexRoute
}

const MinhaContaContaRouteChildren: MinhaContaContaRouteChildren = {
  MinhaContaContaDadosRoute: MinhaContaContaDadosRoute,
  MinhaContaContaPedidosPedidoIdRoute: MinhaContaContaPedidosPedidoIdRoute,
  MinhaContaContaPedidosIndexRoute: MinhaContaContaPedidosIndexRoute,
}

const MinhaContaContaRouteWithChildren = MinhaContaContaRoute._addFileChildren(
  MinhaContaContaRouteChildren,
)

interface RevendedorAreaRouteChildren {
  RevendedorAreaClientesRoute: typeof RevendedorAreaClientesRoute
  RevendedorAreaComissoesRoute: typeof RevendedorAreaComissoesRoute
  RevendedorAreaDadosRoute: typeof RevendedorAreaDadosRoute
  RevendedorAreaVendasRoute: typeof RevendedorAreaVendasRoute
  RevendedorAreaIndexRoute: typeof RevendedorAreaIndexRoute
  RevendedorAreaCampanhasCampanhaIdRoute: typeof RevendedorAreaCampanhasCampanhaIdRoute
  RevendedorAreaCampanhasIndexRoute: typeof RevendedorAreaCampanhasIndexRoute
}

const RevendedorAreaRouteChildren: RevendedorAreaRouteChildren = {
  RevendedorAreaClientesRoute: RevendedorAreaClientesRoute,
  RevendedorAreaComissoesRoute: RevendedorAreaComissoesRoute,
  RevendedorAreaDadosRoute: RevendedorAreaDadosRoute,
  RevendedorAreaVendasRoute: RevendedorAreaVendasRoute,
  RevendedorAreaIndexRoute: RevendedorAreaIndexRoute,
  RevendedorAreaCampanhasCampanhaIdRoute:
    RevendedorAreaCampanhasCampanhaIdRoute,
  RevendedorAreaCampanhasIndexRoute: RevendedorAreaCampanhasIndexRoute,
}

const RevendedorAreaRouteWithChildren = RevendedorAreaRoute._addFileChildren(
  RevendedorAreaRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CalibrarModelosRoute: CalibrarModelosRoute,
  ConfirmarEmailRoute: ConfirmarEmailRoute,
  EsqueciSenhaRoute: EsqueciSenhaRoute,
  RedefinirSenhaRoute: RedefinirSenhaRoute,
  AdminPainelRoute: AdminPainelRouteWithChildren,
  AdminEntrarRoute: AdminEntrarRoute,
  MinhaContaContaRoute: MinhaContaContaRouteWithChildren,
  MinhaContaEntrarRoute: MinhaContaEntrarRoute,
  RevendedorAreaRoute: RevendedorAreaRouteWithChildren,
  RCodeCampaignRoute: RCodeCampaignRoute,
  RCodeIndexRoute: RCodeIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
